export enum commonActionKeys {
  LOAD_BRANCHES_SUCCESS = "LOAD_BRANCHES_SUCCESS",
  CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE",
  CLEAR_VISIT_CATEGORIES = "CLEAR_VISIT_CATEGORIES",
  DISMISS_ERROR_DIALOG = "DISMISS_ERROR_DIALOG",
  LOAD_VISIT_CATEGORIES_SUCCESS = "LOAD_VISIT_CATEGORIES_SUCCESS",
  SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE",
  LOAD_VIDEOS_SUCCESS = "LOAD_VIDEOS_SUCCESS"
}
